/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreGcpInstanceDiskInput } from '../models/RestoreGcpInstanceDiskInput';

export class RestoreGceInstanceConfig {
  /**
  * The zone to restore the vm to
  */
  'zone'?: string;
  /**
  * The machine type to use for the output instance
  */
  'machineType'?: string;
  /**
  * Optional labels to apply to the output instance
  */
  'labels'?: { [key: string]: string; };
  /**
  * The name of the network to use for the output instance
  */
  'networkName'?: string;
  /**
  * The name of the subnet to use for the output instance
  */
  'subnetName'?: string;
  /**
  * The host project of the network to use for the output instance
  */
  'networkHostProject'?: string;
  'diskSettings'?: Array<RestoreGcpInstanceDiskInput>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "zone",
      "baseName": "zone",
      "type": "string",
      "format": ""
    },
    {
      "name": "machineType",
      "baseName": "machineType",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "networkName",
      "baseName": "networkName",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetName",
      "baseName": "subnetName",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkHostProject",
      "baseName": "networkHostProject",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskSettings",
      "baseName": "diskSettings",
      "type": "Array<RestoreGcpInstanceDiskInput>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreGceInstanceConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

